import { FormControl } from "@mui/material";
import { v4 as uuidv4 } from 'uuid';

import './style.css';
import { useForm } from "../../hooks/useForm";
import { useState } from "react";
import { Message } from "../../components/Message";
import { AddClientForm } from "./components/AddClientForm";
import { messagesAdd } from "../../helpers/clientsMessage";

export const AddClient = () => {

    const [formValues, handleInputChange, reset] = useForm({
        name: '', tel: '', email: '', fax: '', movil: '', cif: '', address: '', cp :'', bank : '', contacts : [{id: uuidv4(), contactName:'', jobPosition:'', contactTel: '', contactEmail: ''}]
    });

    const [isCreate, setIsCreate] = useState(false);
    const [headers, setHeaders] = useState({});
    const handleSubmit = (e) => {
        e.preventDefault();
        setHeaders({...formValues, 'contacts': JSON.stringify(formValues.contacts)})
        setIsCreate(!isCreate)
    }

    return (
        <section className="section_formClient">
            <FormControl component='form' className="formClient_container" onSubmit={handleSubmit}>
                <AddClientForm formValues={formValues} handleInputChange={handleInputChange} reset={reset} title='Añadir nuevo' />
                {isCreate && <Message reset={reset} messages={messagesAdd} method='POST' setIsCreate={setIsCreate} headers={headers} />}
            </FormControl>
        </section>
    )
}
